import React from 'react'
import {
  ActivityIndicator,
  StatusBar,
  TouchableOpacity,
  useWindowDimensions,
} from 'react-native'

import {
  Icon,
  SH3,
  Stack,
  XStack,
  colors as zetColors,
} from '@zet/design-system'
import { useExperiments } from '@zet/experiments'

import YoutubePlayer from 'react-native-youtube-iframe'
import { ChangeLanguageBottomSheet } from './components/ChangeLanguageBottomSheet'
import useTrainingVideoPlayer from './useTrainingVideoPlayer'

const TrainingVideoPlayer = ({ route }) => {
  const { height, width } = useWindowDimensions()
  const { data } = useExperiments()
  const { closeCallback } = route?.params
  const {
    isLoading,
    playerRef,
    isFullScreenLoaded,
    isBottomSheetVisible,
    selectedLanguage,
    selectedLanguageVideo,
    handleClose,
    onVideoReady,
    onStateChange,
    handleBottomSheet,
    setSelectedLanguage,
    setIsBottomSheetVisible,
  } = useTrainingVideoPlayer({
    isFullScreenMode: true,
    isLoadingVideo: true,
    training_name: route?.params?.title,
    isPortrait: route?.params?.isPortrait,
    youtube_video_details: route?.params?.youtube_video_details,
    isGenericVideoPlayer: route?.params?.isGenericVideoPlayer,
    videoId: route?.params?.videoId,
  })

  const onDismiss = () => {
    handleClose()
    closeCallback?.()
  }

  const onVideoStateChange = (state: string) => {
    onStateChange(state)
    if (state === 'ended' && closeCallback) {
      handleClose()
      closeCallback?.(true)
    }
  }

  if (!isFullScreenLoaded) {
    return (
      <Stack className="flex flex-1 items-center justify-center">
        <ActivityIndicator
          size={'large'}
          color={zetColors.primary[100]}
          className="self-center"
        />
      </Stack>
    )
  }

  const showChangeLanguageButton = () => {
    if (route?.params?.youtube_video_details) {
      return (
        route?.params?.youtube_video_details.length > 1 ||
        Object.keys(route?.params?.youtube_video_details)?.length > 1
      )
    } else {
      return false
    }
  }

  return (
    <>
      <Stack className="h-full bg-black">
         {isFullScreenLoaded ? (
          <YoutubePlayer
            webViewStyle={{ marginTop: 50 }}
            height={!data?.UI_isCampaignLive ? height - 28 : height}
            width={width}
            play={true}
            ref={playerRef}
            videoId={selectedLanguageVideo?.videoId}
            initialPlayerParams={{
              controls: true,
              preventFullScreen: true,
              showClosedCaptions: true,
            }}
            onReady={onVideoReady}
            onChangeState={onVideoStateChange}
            webViewProps={{
              injectedJavaScript: `var element = document.getElementsByClassName('container')[0];
              element.style.position = 'unset';
              element.style.paddingBottom = 'unset';
              true;
            `,
            }}
          />
        ) : (
          <></>
        )} 

        <XStack className="bg-tertiary-200 absolute top-0 w-full justify-between px-3 py-2">
          <TouchableOpacity
            className="bg-tertiary-100 items-center justify-center rounded p-2"
            // TODO: Check for appling backgroundColor
            onPress={onDismiss}
          >
            <Icon size={20} type="Close" color={zetColors.neutral.white100} />
          </TouchableOpacity>
          {showChangeLanguageButton() ? (
            <TouchableOpacity
              className="bg-tertiary-100 items-center justify-center rounded p-1"
              // TODO: Check for appling backgroundColor
              onPress={handleBottomSheet}
            >
              <XStack className="items-center justify-center gap-1">
                <Icon
                  size={26}
                  type="LanguageOutlined"
                  color={zetColors.neutral.white100}
                />
                <SH3 className="text-white">
                  {selectedLanguage === 'en' ? 'English' : 'Hindi'}
                </SH3>
                <Icon
                  size={26}
                  type="ArrowDown"
                  color={zetColors.neutral.white100}
                />
              </XStack>
            </TouchableOpacity>
          ) : (
            <></>
          )}
        </XStack>
      </Stack>
      {isBottomSheetVisible && (
        <ChangeLanguageBottomSheet
          isBottomSheetVisible={isBottomSheetVisible}
          setIsBottomSheetVisible={setIsBottomSheetVisible}
          selectedLanguage={selectedLanguage}
          setSelectedLanguage={setSelectedLanguage}
          selectedLanguageVideo={selectedLanguageVideo}
        />
      )}
      <StatusBar animated={true} hidden={true} />
    </>
  )
}

export { TrainingVideoPlayer }
